
import XHeader from 'vux/src/components/x-header/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

export default {
components:{
XHeader,
Alert
},
data(){
return{
model:{m_token:this.$route.query.token},
plists:[
{
name: 'Cpu',
content: '2vCpu'
},
{
name: '内存',
content: '8G'
},
{
name: '硬盘',
content: '30G'
},
{
name: '套件包',
content: 'N2云智造'
},
{
name: '使用期限',
content: '一个月'
},
],
box_show: false
}
},
methods: {
goBack(){

this.$router.push({
path : '/learn/buySelect',
query : {}
})
},
show_box(){
let that =this;
this.$http.post(this.global.httpUrl + '/rest/v1/m/user/getFreeN2Server',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.box_show = !this.box_show;
}else{
this.$vux.alert.show({
title: '提示',
content: res.body.message,
})
}
},function(res){
console.log(res.status);
});

},
hide_box(){
this.box_show=false
this.$router.push('/learn/product/index')
}


},

}



// WEBPACK FOOTER //
// ./src/views/learn/buyTryOut.vue